export default __webpack_public_path__ + "static/media/photo12.93623e43.jpg";